import { DurabilitySFDRDurableProportion } from '../../../../types';
export var list = [
    DurabilitySFDRDurableProportion.MIN_TWENTY_FIVE_PERCENT,
    DurabilitySFDRDurableProportion.MIN_FIFTY_PERCENT,
    DurabilitySFDRDurableProportion.MIN_SEVENTY_FIVE_PERCENT,
    DurabilitySFDRDurableProportion.FULL,
];
